<form class="form-container" [formGroup]="formUserData">
  <div class="logo-form-container">
    <img class="logo-form"
      src="https://com-proximate-production-xtracking-resources.s3.us-east-1.amazonaws.com/xtracking/general_design/logo_header.png">
  </div>

  <span class="form-title">¡Te llamamos!</span>
  <span class="form-info">Ingresa los siguientes datos para comunicarnos contigo</span>

  <div class="form-radio-wrapper">
    <mat-radio-group [color]="checkboxColor" class="form-radio-group-container" [formControl]="formGroup.fieldType">
      <mat-radio-button *ngIf="showFirstButtons" [value]="1" class="form-radio-option">
        Quiero que me llamen <strong>¡YA!</strong>
      </mat-radio-button>
      <mat-radio-button [value]="0" class="form-radio-option">
        Agendar una llamada
      </mat-radio-button>
    </mat-radio-group>
  </div>


  <mat-form-field appearance="fill" class="form-input-container">
    <mat-label>Nombre completo</mat-label>
    <input matInput placeholder="Nombres y apellidos" [formControl]="formGroup.fieldName" required>
    <mat-error *ngIf="formGroup.fieldName.invalid">Debes ingresar el nombre</mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill" class="form-input-container">
    <mat-label>Celular</mat-label>
    <input matInput type="number" placeholder="Número celular" [formControl]="formGroup.fieldCellPhone" required>
    <mat-error *ngIf="formGroup.fieldCellPhone.invalid">Debes ingresar un número celular válido</mat-error>
  </mat-form-field>

  <mat-form-field appearance="fill" class="vud-form-input">
    <mat-label>Correo electrónico</mat-label>
    <input matInput type="email" pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" placeholder="Correo Electronico"
      [formControl]="formGroup.fieldEmail" required>
    <mat-error align="end" class="error-text-validator" *ngIf="formGroup.fieldEmail.invalid">Debes ingresar un correo
      válido</mat-error>
  </mat-form-field>

  <div class="container-check">
    <mat-checkbox [color]="checkboxColor" [formControl]="formGroup.fieldTerms"></mat-checkbox>
    <span class="checkbox-text" (click)="openDialogTerms()">Acepto términos y condiciones</span>
  </div>

  <button mat-raised-button class="form-btn" (click)="onClickScheduleCall()">¡Listo llámenme!</button>

  <div class="form-footer-container">
    <img src="./../../../assets/powered.png" class="form-footer-img">
  </div>
</form>